let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("hjivB")]).then(() => parcelRequire('7gC33'));